import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
    (theme) => (
        {
            container: {
                marginTop: theme.spacing(7),
                marginBottom: theme.spacing(8),
                paddingLeft: theme.spacing(0),
                paddingRight: theme.spacing(0),
            },
            iframe: {
                width: "100vw",
                height: "100vh",
                border: 'none',
            }
        }
    )
);

export default useStyles;